export default {
  NONE: 0,
  DIRECT: 1,
  REPEAT: 2,
  PHONE: 3,
  HOTPEPPER: 4,
  CALLCENTER: 5,
  INSHOP: 6,
  FUFUAPP: 10,
  OTHERS: 99,
  options: {
    1: '直接来店',
    2: '次回予約',
    6: '次回予約（お客さま）',
    3: '電話',
    4: 'ホットペッパー',
    5: 'コールセンター',
    10: 'アプリ',
    99: 'その他',
  },
}



// WEBPACK FOOTER //
// ./js/ReservedBy.js